import { Observable } from "rxjs";
import * as http from "../../../services/http.service";
import { SearchResults } from "../../../types/search/search-results.interface";
import { ProductCategory } from "../types/product-category.interface";

export function searchProductCategories(
  searchText: string
): Observable<SearchResults<ProductCategory>> {
  return http.get(`/search/products-categories/?q=${searchText}`);
}
